module.exports = new __parcel__URL__("loading-error.b9457501.svg").toString();